import queryString from 'query-string';

const URL_FILTER_KEYS = [
  'roles',
  'experienceLevel',
  'hiringCapacity',
  'status',
  'remote',
  'internal',
  'searchTerm',
  'rolesHaveChanged',
  'page',
];

/**
 * Returns true when the jobs browse URL includes filter query params that
 * should take precedence over the saved briefsFilters cookie.
 *
 * @param {string} search - location.search (e.g. "?remote=1&roles=Developer")
 * @returns {boolean}
 */
export default function hasUrlFilterParams(search = '') {
  const params = queryString.parse(search);

  return URL_FILTER_KEYS.some((key) => {
    const value = params[key];
    if (value === undefined || value === null || value === '') {
      return false;
    }
    if (Array.isArray(value)) {
      return value.some(
        (item) => item !== undefined && item !== null && item !== ''
      );
    }
    return true;
  });
}
